export default "__VITE_ASSET__328e683f__"